import React, { useContext, useState } from 'react';
import { Channel } from 'talkplus-sdk/dist/model/types';
import AllChatList from '@components/chat/common/allChatList';
import ChatListItem from '@components/chat/common/chatListItem';
import SearchInput from '@components/chat/chatSearch/searchInput';
import EmptySearchChat from '@components/chat/chatSearch/emptySearchChat';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ChatSearchProps {
  handleChannelClick: (channel: Channel) => void;
}

const ChatSearch = ({ handleChannelClick }: ChatSearchProps) => {
  const { channelsData } = useContext<ChatContextType>(ChatContext);

  const [value, setValue] = useState<string>('');
  const filteredList = channelsData?.channels?.filter((channel) => channel.name.includes(value));
  const isEmpty = !!value && filteredList?.length === 0;

  const filteredListEls = filteredList?.map((channel, index) => {
    return <ChatListItem key={index} channel={channel} onClick={() => handleChannelClick(channel)} />;
  });

  const getContentsEl = () => {
    if (!value) return <AllChatList handleChannelClick={handleChannelClick} className={cx('searchAllList')} />;

    if (isEmpty)
      return (
        <>
          <EmptySearchChat />
          <AllChatList handleChannelClick={handleChannelClick} />
        </>
      );

    return (
      <div className={cx('listArea')}>
        <ul className={cx('listWrap')}>{filteredListEls}</ul>
      </div>
    );
  };

  return (
    <div className={cx('chatListArea')}>
      <SearchInput setValue={setValue} />
      {getContentsEl()}
    </div>
  );
};

export default ChatSearch;
